import React from "react";
import SearchProjectsHeader from "./components/SearchProjectsHeader";
import ProjectsByCategory from "./components/ProjectsByCategory";
import CreateProjectButton from "./components/CreateProjectButton";
import ScrollToUpMount from "utils/components/ScrollToUpMount";

const SearchProjects = () => (
  <>
    <ScrollToUpMount />
    <SearchProjectsHeader />
    <ProjectsByCategory />
    <CreateProjectButton />
  </>
);

export default SearchProjects;
